import { actions as eventEmitterActions, name } from '../reducers/eventEmitter';
import { createDomainScopedSelector } from '../selectors/domainSelectorHelper';

const eventEmitterScope = createDomainScopedSelector(name);

const eventEmitterThunk = (componentName, emitterHandler) => {
    return function (dispatch, getState) {
        dispatch(eventEmitterActions.ensureEmitter(componentName));

        let emitter = eventEmitterScope(getState())[componentName];

        emitterHandler(emitter);
    }
};

export default eventEmitterThunk